export default "__VITE_ASSET__CKgMB$10__"